import Vue from 'vue';
import Vuex from 'vuex';
import Api from './utils/Api';
import Config from './utils/Config';

Vue.use(Vuex)

let startPromise: Promise<any>;

export default new Vuex.Store({
	state: {
		initComplete: false,
		tooltip: null,
		alert: null,
		total: 0,
		confirm:{
		  title:null,
		  description:null,
		  confirmCallback:null,
		  cancelCallback:null,
		},
	},






	mutations: {
		initComplete(state) { state.initComplete = true; },

		confirm(state, payload) { state.confirm = payload; },
		
		incrementCount(state, payload) { state.total ++; },

	},






	actions: {
		async startApp({ commit, state, dispatch }, payload) {
			//Security to make sure startApp isn't executed twice if changing URL while loading
			if (startPromise && payload.force !== true) return startPromise;
			
			let res = await Api.get("message");
			state.total = res.total;
			state.initComplete = false;

			startPromise = new Promise(async (resolve, reject) => {
				commit("initComplete", true);
				resolve();
			});

			return startPromise;
		},

		openTooltip({state}, payload) { state.tooltip = payload; },
		
		closeTooltip({state}) { state.tooltip = null; },

		confirm({commit}, payload) { commit("confirm", payload); },
		
		incrementCount({commit}) { commit("incrementCount"); },

	}
})
